<script setup>
defineProps({
    post: { type: Object, required: true },
})

const formatDate = (iso) =>
    iso ? new Date(iso).toLocaleDateString('cs-CZ', { day: 'numeric', month: 'long', year: 'numeric' }) : ''
</script>

<template>
    <article
        class="group flex flex-col overflow-hidden rounded-2xl border border-zinc-200 bg-white transition-shadow hover:shadow-md"
    >
        <Link
            class="flex h-full flex-col"
            :href="`/blog/${post.slug}`"
        >
            <div class="aspect-[16/9] overflow-hidden bg-zinc-100">
                <img
                    class="size-full object-cover transition-transform duration-300 group-hover:scale-105"
                    v-if="post.cover_image_url"
                    :src="post.cover_image_url"
                    :alt="post.title"
                    loading="lazy"
                />
            </div>

            <div class="flex flex-1 flex-col p-6">
                <div class="flex flex-wrap items-center gap-x-3 gap-y-1 text-xs font-medium tracking-wide uppercase">
                    <span
                        class="text-accent-600"
                        v-if="post.category"
                    >
                        {{ post.category.name }}
                    </span>

                    <time
                        class="text-zinc-500"
                        v-if="post.published_at"
                        :datetime="post.published_at"
                    >
                        {{ formatDate(post.published_at) }}
                    </time>

                    <span
                        class="text-zinc-400"
                        v-if="post.reading_time"
                    >
                        {{ post.reading_time }} min čtení
                    </span>
                </div>

                <h2 class="text-brand-900 mt-3 text-xl font-bold tracking-tight">
                    {{ post.title }}
                </h2>

                <p
                    class="mt-3 text-base leading-relaxed text-zinc-600"
                    v-if="post.excerpt"
                >
                    {{ post.excerpt }}
                </p>

                <div class="mt-6 flex-1" />

                <span class="text-accent-600 text-sm font-semibold">Číst dál →</span>
            </div>
        </Link>
    </article>
</template>
